const connectConfig = {
  // backendURL: "http://192.168.10.56:8083",
  backendURL: "https://api-office.pharmagroup.com.hk",
  fileFolder: "/uploads",
  s3: "https://3cb-public-images.s3.ap-southeast-1.amazonaws.com",
};

export default connectConfig;
